<template>
    <v-container>
        <v-card>
            <v-card-title>
                Renew Subscription
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12 md6>
                        <table>
                            <tr>
                                <td style="width: 160px">
                                    {{ $t("Code") }}
                                </td>
                                <td style="width: 20px;">:</td>
                                <td>
                                    {{ subscription.code }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t("Customer") }}
                                </td>
                                <td>:</td>
                                <td>
                                    {{ subscription.customer_name }}
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    {{ $t("Membership") }}
                                </td>
                                <td>:</td>
                                <td>
                                    {{ subscription.membership_name }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t("Starts at") }}
                                </td>
                                <td>:</td>
                                <td>
                                    {{ subscription.formatted_start_date }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ $t("Ends at") }}
                                </td>
                                <td>:</td>
                                <td>
                                    {{ subscription.formatted_end_date }}
                                </td>
                            </tr>
                        </table>
                    </v-flex>

                    <v-flex xs12 md6>
                        <img :src="subscription.image_url" style="width: 300px; height: auto" />
                    </v-flex>

                    <v-flex xs12>
                        <v-btn @click="renewCallback()" :loading="item.processing" :disabled="item.processing">
                            {{ $t("Renew This Membership") }}
                        </v-btn>
                    </v-flex>
                </v-layout>

            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        props: ["subscription"],

        data() {
            return {
                item: this.$inertia.form({
                    parent_id: this.subscription.id,
                }),
            };
        },

        methods: {
            renewCallback() {
                this.item.post(this.$route("central.subscriptions.renew", {
                    subscription: this.subscription.uuid,
                }));
            },
        }
    };
</script>